<template>
    <div class="loading small">
        <i class="fas fa-sync fa-spin"></i>
        <p>Loading</p>
    </div>
</template>

<script>
    export default {
        name: 'LoadingSmall'
    }
</script>


// WEBPACK FOOTER //
// LoadingSmall.vue?92b8b4b8